




















































import { Component, Vue } from 'vue-property-decorator';
import { IPriority } from '@/interfaces';
import { readPriorities, dispatchGetPriorities, dispatchUpdatePriority } from '@/store/admin/accessors';

@Component
export default class Priorities extends Vue {
  public dialog: boolean = false;
  public editedPriority = {
    id: 0,
    rate: 0,
  };
  public headers = [
    {
      text: this.$vuetify.lang.t('$vuetify.name'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.ratePerSecond'),
      sortable: true,
      value: 'rate',
      align: 'left',
    },
    {
      text: this.$vuetify.lang.t('$vuetify.actions'),
      value: 'id',
    },
  ];

  get priorities() {
    return readPriorities(this.$store);
  }

  public async mounted() {
    await dispatchGetPriorities(this.$store);
  }

  public edit(priority: IPriority) {
    this.editedPriority.id = priority.id;
    this.editedPriority.rate = priority.rate;
    this.dialog = true;
  }

  public close() {
    this.dialog = false;
  }

  public async save() {
    await dispatchUpdatePriority(this.$store, {
      id: this.editedPriority.id,
      priority: { rate: this.editedPriority.rate },
    });
    this.close();
  }
}
